import React, { Component } from 'react';
import { Container, Header, Segment } from 'semantic-ui-react';

import './index.css';

class LandingPage extends Component {
  render() {
    const { tittel, bekreftelse, undersokelse } = this.props;

    var z1cdtan519ealf4;
    let s = document.createElement('script'),
      options = {
        userName: 'hanenno',
        formHash: 'z1cdtan519ealf4',
        autoResize: true,
        height: '466',
        async: true,
        host: 'wufoo.eu',
        header: 'hide',
        ssl: true,
      };
    s.src =
      ('https:' === document.location.protocol ? 'https://' : 'http://') +
      'www.wufoo.eu/scripts/embed/form.js';
    s.onload = s.onreadystatechange = function() {
      let WufooForm = window.WufooForm || {};
      var rs = this.readyState;
      if (rs) if (rs !== 'complete') if (rs !== 'loaded') return;
      try {
        z1cdtan519ealf4 = new WufooForm();
        z1cdtan519ealf4.initialize(options);
        z1cdtan519ealf4.display();
      } catch (e) {}
    };
    var scr = document.getElementsByTagName('script')[0],
      par = scr.parentNode;
    par.insertBefore(s, scr);

    return (
      <Container text textAlign="center">
        <Header as="h1">{tittel}</Header>

        <Segment basic size="huge">
          {bekreftelse}
        </Segment>

        <p>{undersokelse}</p>

        <div id="wufoo-z1cdtan519ealf4" />
      </Container>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/Thanks/index.js